var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d654ca28f4499b813481a56c9b997d8d93e42325"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-nextjs@lutech"]={id:"d654ca28f4499b813481a56c9b997d8d93e42325"};
      